export const TOPICS = 'TOPICS';
export const CONTENT = 'CONTENT';
export const LINKS = 'LINKS';
